import dologo from './dologo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <img src={dologo} alt="Local" />
    </div>
  );
}

export default App;


